<template>
    <crud-facecade
        :url="url"
        :columns="columnList"
        :tableHeight="tableHeight"
        :buttons="buttons"
        v-wechat-title="title"
        :addButton="{ permission: 'permission:create' }"
        :deleteButton="{ permission: 'permission:delete' }"
        :updateButton="{ permission: 'permission:update' }"
    >
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `OrganizationOperationBed`,
    props: {

    },
    data() {
        return {
            title: `组织架构-复苏床位`,
            url: { baseURL: `/api/AcisSystem/RecoveryBed`,
                get: () => {
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/AcisSystem/RecoveryBed/Get`)
                        req.then(data => {
                            resolve(_.filter(data, d => {
                                return _.some(this.recovery_ward_auth, { value: d.dic_recovery_ward_id })
                            }))
                        }).catch(e => reject(e))
                    })
                } },
            buttons: []
        }
    },
    created() {
        this.$store.dispatch(`ADD_RECOVERY_WARD_AUTH`)
    },
    computed: {
        ...mapGetters([`recovery_ward_auth`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `number`,
                prop: `display_order`,
                label: `排序`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                readonly: false,
                sortable: true,
                isDisplayOrder: true
            }, {
                type: `string`,
                prop: `code`,
                label: `编码`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `name`,
                label: `名称`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `select`,
                prop: `dic_recovery_ward_id`,
                label: `复苏室`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: this[`recovery_ward_auth`],
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `abbr`,
                label: `缩写`,
                width: `180`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: false,
                sortable: false
            }, {
                type: `string`,
                prop: `description`,
                label: `描述`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true
            }, {
                type: `rbool`,
                prop: `is_deleted`,
                label: `状态`,
                width: `70`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: false,
                readonly: false,
                options: `is_enabled`,
                default: false
            }, {
                type: `select`,
                prop: `is_hide_right`,
                label: `是否隐藏右侧体征栏`,
                width: `120`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: `enum_bool`,
                default: false
            }, {
                type: `string`,
                prop: `qr_code`,
                label: `二维码`,
                width: `180`,
                isListable: false,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: false
            }
            ]
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Organization/RecoveryBed/Index.vue